import React, { useState, useContext } from 'react';
import { Form, Button, Alert, Card } from 'react-bootstrap';
import api from '../../utils/api';
import AuthContext from '../../context/AuthContext';

const ProfileManager = () => {
  const { user, login } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    name: user?.name || '',
    email: user?.email || '',
    password: '',
    confirmPassword: '',
  });
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const updateData = {
        name: formData.name,
        email: formData.email,
      };
      if (formData.password) {
        updateData.password = formData.password;
      }

      const { data } = await api.put('/users/profile', updateData);
      
      // Update local storage and context with new user info
      login(data);
      setMessage('Profile updated successfully');
      setFormData({ ...formData, password: '', confirmPassword: '' });
    } catch (err) {
      if (err.response && (err.response.status === 401 || err.response.status === 404)) {
         alert('Session expired or user not found. Please log in again.');
         // Force logout logic here if possible, or let the user handle it
         // Since we can't easily access 'logout' from here without destructuring it from context:
         // window.location.href = '/login'; // Quick and dirty force logout
      }
      setError(err.response?.data?.message || 'Error updating profile');
    }
  };

  return (
    <div className="d-flex justify-content-center">
      <Card style={{ width: '100%', maxWidth: '600px' }} className="border-0">
        <Card.Body>
          <h3 className="mb-4">My Profile</h3>
          {message && <Alert variant="success">{message}</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}
          
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control name="name" value={formData.name} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} required />
            </Form.Group>
            
            <hr />
            <h5 className="mb-3">Change Password</h5>
            
            <Form.Group className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Leave blank to keep current" />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="Confirm new password" />
            </Form.Group>

            <Button variant="primary" type="submit">Update Profile</Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ProfileManager;
